import { DestroyRef } from "@angular/core";
import { Flight } from "../../../../models/flight.model";
import { FLIGHT_FUEL_FIELDS, MaxTank, buildFuelGroup } from "../../fuel-row/fuel-row";

/** The fuel the flight itself keeps: its name, arrival, planned, refuel and total, and where it was first refuelled. */
export function buildFlightFuelGroup(flight: Flight, units: string[], maxTank: MaxTank, destroyRef: DestroyRef) {
    return buildFuelGroup(
        {
            name: flight.fuelName,
            arrival: flight.fuelArrival,
            planned: flight.fuelPlanned,
            refuel: flight.refuel,
            total: flight.totalFuel,
            location: flight.firstRefuelLocation,
        },
        { fields: FLIGHT_FUEL_FIELDS, units: units, maxTank: maxTank, withId: false, refuelRequired: false },
        destroyRef,
    );
}
